import { html } from "lit";
import { getDummyText } from "../utils";

export const Template = () => {
    return html`
        <ux-iws-sidebar>
            <ux-tab-container no-navigation>
                <ux-tab
                    tab-id="contacts"
                    name="Contacts"
                    data-icon-name="contact-list"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Rhoncus rutrum velit
                    </h3>
                    <p>${getDummyText(700)}</p>
                </ux-tab>
                <ux-tab
                    tab-id="frequently-searched-areas"
                    name="Frequently searched"
                    data-icon-name="squares-magnifier"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Lorem ipsum
                    </h3>
                    <button class="ux-button">Lorem ipsum</button>
                    <p>${getDummyText(160)}</p>
                    <button class="ux-button ux-button--green">
                        Lorem ipsum
                    </button>
                    <p>${getDummyText(130)}</p>
                </ux-tab>
                <ux-tab
                    tab-id="services"
                    name="Services"
                    data-icon-name="avatar"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Rhoncus rutrum velit
                    </h3>
                    <button class="ux-button ux-button--green">
                        Lorem ipsum
                    </button>
                    <p>${getDummyText(3000)}</p>
                </ux-tab>
                <ux-tab
                    tab-id="downloads"
                    name="downloads"
                    data-icon-name="arrow-download"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Lorem ipsum
                    </h3>
                    <button class="ux-button">
                        Lorem ipsum
                    </button>
                </ux-tab>
                <ux-tab
                    tab-id="calendar"
                    name="Services"
                    data-icon-name="calendar"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Rhoncus rutrum velit
                    </h3>
                    <ux-accordion>
                        <div slot="title">
                            Some expandible information
                        </div>
                        <div>
                            ${getDummyText(300)}
                        </div>
                    </ux-accordion>
                    <p>${getDummyText(430)}</p>
                </ux-tab>
                <ux-tab tab-id="shop" name="shop" data-icon-name="cart">
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Lorem ipsum
                    </h3>
                    <p>
                        ${getDummyText(500)}
                    </p>
                </ux-tab>
                <ux-tab
                    tab-id="social-share"
                    name="Share"
                    data-icon-name="share-nodes"
                >
                    <h3 class="ux-text-headline ux-text-headline--medium">
                        Rhoncus rutrum velit
                    </h3>
                    <p>${getDummyText(430)}</p>
                </ux-tab>
            </ux-tab-container>
        </ux-iws-sidebar>
    `;
};
